import FluxBolus from "./FluxBolus";

const FluxBolusTab = ({ metrics, patient }) => {
  return <FluxBolus metrics={metrics} patient={patient} />;
};

export default FluxBolusTab;
